import { Link } from "react-router-dom";
import type { AboTermin } from "../../hooks/useKalenderAbos";

/**
 * Die Termine der abonnierten Kalender für einen Tag — nur zum Lesen.
 * Steht auf dem Telefon in der Tagesansicht unter dem Kalender und am Rechner
 * im Tagesblatt (Seitenleiste) unter den Kontor-Terminen.
 */
export function AboTerminListe({ dateIso, termine, fehler, hatAbos, laedt, onAbo }: {
  dateIso: string;
  termine: AboTermin[];
  fehler: { kalender: string; text: string }[];
  hatAbos: boolean;
  laedt: boolean;
  onAbo: (t: AboTermin) => void;
}) {
  return (
    <>
      {termine.length > 0 && (
        <>
          <div className="pl-tag-trenner">Aus deinen Kalendern</div>
          <div className="pl-tag-liste">
            {termine.map((t, i) => (
              <div key={`${t.abo_id}-${t.start}-${i}`} className="pl-tag-eintrag">
                <button type="button" className="pl-tag-haupt" onClick={() => onAbo(t)}>
                  <span className="pl-tag-balken" style={{ background: t.farbe }} />
                  <span className="pl-tag-zeit">{zeitVon(t, dateIso)}<small>{zeitBis(t, dateIso)}</small></span>
                  <span className="pl-tag-inhalt">
                    <span className="pl-tag-was">{t.titel}</span>
                    <span className="pl-tag-wer">{[t.von_wem ? `${t.kalender} (${t.von_wem})` : t.kalender, t.ort].filter(Boolean).join(" · ")}</span>
                  </span>
                  <span className="pl-tag-pfeil" aria-hidden="true">›</span>
                </button>
              </div>
            ))}
          </div>
        </>
      )}
      {laedt && <p className="pl-tag-hinweis">Deine Kalender werden geladen …</p>}
      {/* Ein Kalender, der stumm fehlt, ist schlimmer als einer, der sich beschwert. */}
      {fehler.map((f) => (
        <p key={f.kalender} className="pl-tag-fehler">{f.kalender}: {f.text}</p>
      ))}
      {!hatAbos && (
        <p className="pl-tag-hinweis">
          Deinen Apple-Kalender hier sehen? In den <Link to="/einstellungen">Einstellungen</Link> abonnieren.
        </p>
      )}
    </>
  );
}

/** Beginn am gewählten Tag — ein Termin, der gestern begann, läuft heute „…". */
function zeitVon(t: AboTermin, tag: string): string {
  if (t.ganztags) return "ganzt.";
  return t.start.slice(0, 10) < tag ? "…" : t.start.slice(11, 16);
}

function zeitBis(t: AboTermin, tag: string): string {
  if (t.ganztags || t.ende <= t.start) return "";
  return t.ende.slice(0, 10) > tag ? "…" : t.ende.slice(11, 16);
}
